const GAMES = ["WARZONE", "VALORANT", "COUNTER-STRIKE 2", "APEX LEGENDS", "FORTNITE", "PUBG", "THE FINALS", "RAINBOW SIX"];

export function TrustBand() {
    return (
        <section className="border-y border-white/10 bg-surface/40 py-6" data-testid="trust-band">
            <div className="max-w-7xl mx-auto px-5 md:px-10">
                <p className="text-center text-[11px] font-mono uppercase tracking-[0.2em] text-muted-foreground mb-4">
                    Coaching across every major FPS
                </p>
                <div className="relative overflow-hidden [mask-image:linear-gradient(90deg,transparent,black_12%,black_88%,transparent)]">
                    <div className="flex gap-12 ww-marquee whitespace-nowrap w-max">
                        {[...GAMES, ...GAMES].map((g, i) => (
                            <span key={i} className="font-heading font-bold text-base sm:text-lg text-white/30 hover:text-white/70 transition-colors">{g}</span>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
}
